import { render, staticRenderFns } from "./IpAccessControl.vue?vue&type=template&id=7bbf6cae&scoped=true"
import script from "./IpAccessControl.vue?vue&type=script&lang=js"
export * from "./IpAccessControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bbf6cae",
  null
  
)

export default component.exports